/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner } from "components/Spinner";
import { navigateToIndex } from "app/navigation";
import { setFailedRequestUrl } from "reducers/common";
import SurveyNotificationModal from "components/retailerSurvey/SurveyNotificationModal";
/* Project Import will be here */

const PrivateRoutesAuthWrapper = Component => {
    class PrivateRoutesAuthCheck extends React.Component {
        constructor(props) {
            super(props);

            /* Scroll to top of the page on every refresh / initial page load */
            window.scrollTo(0, 0);

            if (!this.props.localStore.token) {
                /* Capture the current url to redirect after login */
                this.props.actions.setFailedRequestUrl(window.location.pathname);

                /* Redirect to login page when the token not available */
                this.props.actions.navigateToIndex();

                return false;
            }
        }

        renderComp = () => {
            const { appSettings, translate, localStore } = this.props;

            /* Check for auto logout */
            if (localStore.token && !localStore.selectedWholesaler && appSettings.isAppSettingsConfigLoaded) {
                /* Redirect to login page when the token not available */
                this.props.actions.navigateToIndex();
            }

            /* Render private route */
            if (localStore.token && localStore.selectedWholesaler && appSettings.isAppSettingsConfigLoaded)
                return (
                    <React.Fragment>
                        <Component {...this.props} />
                        {this.props.surveyNotification.data.length > 0 &&
                            <SurveyNotificationModal />
                        }
                    </React.Fragment>
                );
            else {
                return (
                    <div id="overlay">
                        <Spinner message={translate("common.loading.appLoading")} />
                    </div>
                );
            }
        }

        render() {
            return this.renderComp();
        }
    }

    const mapStateToProps = state => {
        return {
            localStore: state.localStore,
            appSettings: state.appSettings,
            translate: getTranslate(state.locale),
            surveyNotification: state.survey.surveyNotification
        };
    };

    const mapDispatchToProps = dispatch => {
        return {
            actions: bindActionCreators({
                navigateToIndex,
                setFailedRequestUrl
            }, dispatch)
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(PrivateRoutesAuthCheck);
};

export default PrivateRoutesAuthWrapper;